<template lang="pug">
    layout
        template(slot="title")

            // Title
            title-component(:title="$t('markets.title')" type="h1")

        div
            frequency-component(:frequency="refreshTime" :refreshAction="refreshAction")

            div.marketsTableProgress.mt-5
                v-progress-linear(
                    v-if="isLoading"
                    indeterminate
                    color="yellow darken-2"
                )

            v-simple-table.marketsTable.c-table
                template(v-slot:default)
                    thead
                        tr
                            th(v-for="item in $t('markets.headers')") {{ item.label }}
                    tbody
                        tr(v-if="item.ask_price" v-for="(item, key) in dataList" :key="key")
                            td( v-for="header in $t('markets.headers')") {{ item[header.key] }}
                        tr(v-else)
                            td( colspan="8") No data
                                 //   data-flow-component(:dataValue="itemValue")

            div(v-if="dataGraphList.length")
                v-divider.my-5
                market-charts(:chartData="dataGraphList")
</template>

<script>
    import { Title, Frequency, DataFlow } from '~components';
    import Layout from '../Layout';

    import { mapActions, mapGetters } from 'vuex';
    import { markets } from '~api';
    import MarketCharts from './MarketCharts';

    export default {
        components: {
            Layout,
            MarketCharts,
            TitleComponent: Title,
            DataFlowComponent: DataFlow,
            FrequencyComponent: Frequency,
        },
        data() {
            return {
                dataList: [],
                dataGraphList: [],
                isLoading: false,
            };
        },
        computed: {
            ...mapGetters('markets', ['refreshTime']),
        },
        async created() {
            // Get refresh time
            this.getRefreshTime();

            // Get data list on first load
            this.refreshAction();
        },
        methods: {
            ...mapActions('markets', ['getRefreshTime']),

            /**
             * Get data list
             */
            async refreshAction() {
                this.isLoading = true;

                const [respGraph, resp] = await Promise.all([
                    markets.getGraphData(),
                    markets.getMarketData(),
                ]);

                if (respGraph.ok) this.dataGraphList = respGraph.data;
                if (resp.ok) this.dataList = resp.data;

                this.isLoading = false;
            },
        },
    };
</script>

<style lang="stylus" scoped>
    .marketsTable
        td
            text-align: left

    .marketsTableProgress
        height: 15px
</style>
